export { default } from "./Tabs"